import { UserStore } from "@/services/stores/types";
import { StateCreator } from "zustand";

export const userStore: StateCreator<UserStore> = set => ({
  user: null,
  setUser: user => set(() => ({ user })),
});
